module.exports = __webpack_public_path__ + "static/Q3Answer6_Sandwhich_ReidZura-d5dcd7945c29e5eddace87c4f712c656.jpg";